module.exports = __webpack_public_path__ + "static/media/Rounds-06.beefa5e2.png";